import type { ChangeEvent, PropsWithChildren, ReactNode } from 'react'
import styles from './Checkbox.module.scss'

export interface CheckboxProps extends PropsWithChildren {
  id: string
  disabled?: boolean
  checked?: boolean
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
}

export function Checkbox({ id, children, disabled, checked, onChange }: CheckboxProps): ReactNode {
  return (
    <label htmlFor={id} className={styles.Checkbox}>
      <input id={id} type="checkbox" disabled={disabled} checked={checked} onChange={onChange} />
      <div className={styles.Checkbox__checkmark} />
      <span>{children}</span>
    </label>
  )
}
